import React, { useEffect } from "react";
import { content } from "../../utils/content/product";

export default function Timer({ lang }) {
  const [hours, setHours] = React.useState(0);
  const [minutes, setMinutes] = React.useState(0);
  const [seconds, setSeconds] = React.useState(0);
  useEffect(() => {
    setTimeout(() => {
      let currentTime = new Date();
      let hour = currentTime.getHours();
      let minute = currentTime.getMinutes();
      let second = currentTime.getSeconds();
      setHours(24 - hour);
      setMinutes(60 - minute);
      setSeconds(60 - second);
    }, 1000);
  }, [hours, minutes, seconds]);

  return (
    <div>
      <div className="flex gap-4 mt-3">
        <div className="text-center bg-tn-red rounded-lg text-white text-2xl px-4 py-2 font-bold">
          {hours} <br></br>
          <span className="text-xl font-normal"> {content["hrs"][lang]}</span>
        </div>
        <div className="text-center bg-tn-red rounded-lg text-white text-2xl px-4 py-2 font-bold">
          {minutes} <br></br>
          <span className="text-xl font-normal"> {content["mins"][lang]}</span>
        </div>

        <div className="text-center bg-tn-red rounded-lg text-white text-2xl px-4 py-2 font-bold">
          {seconds} <br></br>
          <span className="text-xl font-normal">{content["secs"][lang]}</span>
        </div>
      </div>
    </div>
  );
}
